// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.
import {
  type AssetAllocationStrategy,
  type SearchAssetClass,
  type SearchText,
  type StrategyId,
} from '@shared/data-access/interfaces/api/ai/asset-allocation';
import { aiApi } from '@shared/data-access/api-base/citec-ai-api';
import { cleanPayload } from '@shared/data-access/utils/clean-payload';
import { assetAllocationAssetClassPayload } from '@shared/data-access/utils/payloads/ai';

export const assetAllocationApi = aiApi.injectEndpoints({
  endpoints: build => ({
    strategy: build.query<AssetAllocationStrategy, { params: StrategyId }>({
      query: ({ params }) => ({
        url: '/asset_allocation/strategy/',
        method: 'GET',
        params: params,
      }),
      providesTags: [{ type: 'AssetAllocation', id: 'Strategy' }],
    }),
    assetClassSearch: build.query<SearchAssetClass, { payload: SearchText }>({
      query: ({ payload }) => ({
        url: '/asset_allocation/asset_class/search/',
        method: 'POST',
        body: cleanPayload(payload, assetAllocationAssetClassPayload),
      }),
      providesTags: [{ type: 'AssetAllocation', id: 'Search' }],
    }),
  }),
});
